import { DrawerState, DrawerActionTypes } from './drawerTypes';
import { Action } from 'redux';

const initialState: DrawerState = {
  isMobileOpen: false,
};

export default function drawerReducer(
  state = initialState,
  action: Action<DrawerActionTypes>,
): DrawerState {
  switch (action.type) {
    case DrawerActionTypes.OPEN_MOBILE_DRAWER:
      return {
        ...state,
        isMobileOpen: true,
      };

    case DrawerActionTypes.CLOSE_MOBILE_DRAWER:
      return {
        ...state,
        isMobileOpen: false,
      };

    default:
      return state;
  }
}
